const Req = {
  symbol: 'req',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM10 6v1.722l6.916.001c.892-.012 1.547.062 1.963.221 1.506.513 2.536 2.065 2.415 3.622-.038 1.802-1.645 3.395-3.482 3.444-1.592.022-3.185.002-4.778.01 1.495 2.44 3.74 6.1 6.735 10.98l1.43-.898a5181.37 5181.37 0 0 0-5.165-8.418c1.007-.018 2.037.085 3.018-.193 1.546-.409 2.868-1.538 3.5-2.98.698-1.567.578-3.468-.34-4.925a5.389 5.389 0 0 0-3.59-2.436c-.44-.093-1.113-.143-2.015-.15H10z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#6CFCCD"/><path fill="#FFF" d="M10 6h6.607c.902.007 1.574.057 2.016.15a5.389 5.389 0 0 1 3.589 2.436c.918 1.457 1.038 3.358.34 4.925-.632 1.442-1.954 2.571-3.5 2.98-.981.278-2.01.175-3.018.193a5181.37 5181.37 0 0 1 5.165 8.418L19.77 26c-2.995-4.88-5.24-8.54-6.735-10.98 1.593-.008 3.186.012 4.778-.01 1.837-.049 3.444-1.642 3.482-3.444.12-1.557-.91-3.11-2.415-3.622-.416-.159-1.07-.233-1.963-.22L10 7.721V6z"/></g>`;
  }
};
export default Req;
